require('form-serializer');
require('./blocks/ripple/ripple');
require('./blocks/tags.less');
require('./blocks/tabs/tabs');
require('./blocks/review.less');
require('./blocks/reviews/reviews');
require('./blocks/complex-buy.less');
require('./blocks/impromptu/impromptu-review');
require('./blocks/impromptu/impromptu-one-click');
require('./blocks/fancybox/fancybox');
require('./blocks/product/product');
require('./blocks/seo-text.less');
require('./blocks/special-action.less');
require('./blocks/impromptu/impromptu-product-gift');
require('./blocks/cart/cart');
require('./blocks/soc-marks');
require('./blocks/benefit/benefit.less');
require('./blocks/beautician-price-request/beautician-price-request');
require('./blocks/product-split/product-split');



// WEBPACK FOOTER //
// ./product.js